import { type DefaultReactSuggestionItem, getDefaultReactSlashMenuItems } from "@blocknote/react";
import type { BnEditor } from "blocks-schema";
import type { PersistedTheme } from "schemas";
import { insertAppointmentLinkBlockItems } from "./insertAppointmentLinkBlockItems";
import { insertButtonBlockItems } from "./insertButtonBlockItems";
import { insertDividerBlockItems } from "./insertDividerBlockItems";
import { insertFormLinkBlockItems } from "./insertFormLinkBlockItems";
import { insertImageBlockItems } from "./insertImageBlockItems";
import { insertImageWithChildrenBlockItems } from "./insertImageWithChildrenBlockItems";
import { insertPageBlockItems } from "./insertPageBlockItems";
import { insertSocialLinksBlockItems } from "./insertSocialLinksBlockItems";
import { insertTwoImagesBlockItems } from "./insertTwoImagesBlockItems";
import { insertVideoBlockItems } from "./insertVideoBlockItems";

interface Args {
  parent: "Campaign" | "Page";
  theme: PersistedTheme;
  editor: BnEditor;
}

export function getCustomSlashMenuItems({ parent, theme, editor }: Args): DefaultReactSuggestionItem[] {
  const parentBlock = editor.getParentBlock(editor.getTextCursorPosition().block.id);
  const limitedSelection = parentBlock?.type === "columnBlock";

  if (limitedSelection) {
    return [
      ...getDefaultReactSlashMenuItems(editor),
      ...insertButtonBlockItems(editor, theme),
      ...(parent === "Page" ? insertPageBlockItems(editor) : []),
      ...insertFormLinkBlockItems(editor, theme),
      ...insertDividerBlockItems(editor),
    ];
  }

  return [
    ...getDefaultReactSlashMenuItems(editor),
    ...insertButtonBlockItems(editor, theme),
    ...(parent === "Page" ? insertPageBlockItems(editor) : []),
    ...insertFormLinkBlockItems(editor, theme),
    ...insertAppointmentLinkBlockItems(editor, theme),
    ...insertVideoBlockItems(editor),
    ...insertSocialLinksBlockItems(editor, theme),
    ...insertImageBlockItems(editor),
    ...insertImageWithChildrenBlockItems(editor),
    ...insertTwoImagesBlockItems(editor),
    ...insertDividerBlockItems(editor),
  ];
}
